export const transformBodyByHttpMethod = (
  method: string,
  body: Record<string, string | number> | FormData | undefined
) => {
  if (method === 'GET' || method === 'HEAD') {
    return undefined
  }

  return body
}
